import { Loading, Notify } from "quasar";
import { reactive } from "vue";
import { config } from './config'
/** GLOBAL CONSTANTS */
const user = reactive({
  name: false,
  area: false,
  areas: [],
  menu: [],
  mail: false,
  logged: false,
  adm: false,
  grant: function (user) {
    if (this.name === user || this.adm)
      return true;
    Notify.create({ message: "Usuario no autorizado", color: "negative" });
    return false;
  }
})

async function db(url, post, show = true) {
  show ? Loading.show() : "";;
  try {
    const baseUrl = import.meta.env.DEV
      ? `${window.location.protocol}//${window.location.hostname}/proxy/8000`
      : `${window.location.protocol}//${window.location.hostname}`;
    const requestBody = Array.isArray(post) ? post : [post];
    const response = await fetch(
      `${baseUrl}${url}`, // La URL base donde el PHP procesa las peticiones
      {
        credentials: "include",
        method: "POST",
        body: JSON.stringify(requestBody) // ¡Aquí enviamos el array de operaciones!
      }
    );
    Loading.hide();
    let res = await response.json();
    // Si es un array de 1 file, res = esa fila
    if (Array.isArray(res) && res.length === 1 && Array.isArray(res[0])) {
      res = res[0];
      const color = res.success ? 'positive' : 'negative';
      if (res.message && show)
        Notify.create({ message: res.message, color: color });
    } else if (Array.isArray(res)) {
      // si el array tiene más de 1 fila
      res.forEach(item => {
        const color = item.success ? 'positive' : 'negative';
        if (item.message && show)
          Notify.create({ message: item.message, color: color });
      });
    } else {
      // si no tiene array, simplemente devuelve el valor en un objeto
      const color = res.success ? 'positive' : 'negative';
      if (res.message && show)
        Notify.create({ message: res.message, color: color });
    }
    return res;
  } catch (error) {
    Loading.hide();
    Notify.create({ message: 'JSON: ' + error, color: 'negative' });
    console.error('Error:', error);
    throw error;
  }
}

/** Funciones de Base de datos */
const data = {
  // const personas = [
  //   { nombre: 'Juan', edad: 30, ciudad: 'Madrid' },
  //   { nombre: 'Ana', edad: 25, ciudad: 'Barcelona' },
  //   { nombre: 'Pedro', edad: 35, ciudad: 'Sevilla' }
  //   { nombre: 'Jose', edad: 25, ciudad: 'Sevilla' }
  // ];
  /**
   * get(personas,"edad", 25, "nombre") // Ana
   * getRow(personas,"ciudad","Sevilla") // { nombre: 'Pedro', edad: 35, ciudad: 'Sevilla' }
   * getRows(personas,"ciudad","Sevilla") // [{ nombre: 'Pedro', edad: 35, ciudad: 'Sevilla' },{ nombre: 'Jose', edad: 25, ciudad: 'Sevilla' }]
   * selectRowsUnique(personas,"edad") // // devuelve objeto con lineas 1,2,3 (la 4 como tiene la edad de 2, no )
   * selectColumn(personas, "nombre") // [Juan,Ana,Pedro,Jose]
   * sumColumn(personas,"edad") // 115
    * delete(personas, "edad", 25 ) // elimina la segunda y cuarta linea
   */

  /** Obtiene el valor de un object donde el campo es igual a un valor */
  get: function (object, whereField, equalTo, fieldToObtainValue) {
    return object.find(item => item[whereField] === equalTo)?.[fieldToObtainValue];
    // return (object.find(item => item[whereField] === equalTo) || {})[fieldToObtainValue] || null;
  },
  getRow: function selectRows(object, whereField, equalTo) {
    return object.find(item => item[whereField] === equalTo);
  },
  getRows: function selectRows(object, whereField, equalTo) {
    return object.filter(item => item[whereField] === equalTo);
  },
  getRowsUnique: function (object, key) {
    return [...new Map(object.map(obj => [obj[key], obj])).values()];
  },
  getColumn: function (object, column) {
    return object.map(item => item[column]);
  },
  getSum: function (object, column) {
    return object.reduce((suma, elemento) => suma + elemento[column], 0);
  },
  del: function (object, whereField, equalTo) {
    return object.filter(item => item[whereField] !== equalTo);
  },
  clone: function (obj) { // crea una nueva instancia de un objeto, si obj es { a: 1, b: { c: 2 } }, después de JSON.stringify(obj), obtendrás la cadena {"a":1,"b":{"c":2}}.
    return JSON.parse(JSON.stringify(obj))
  },
  getNow: function () {
    const now = new Date();
    return now.toISOString().slice(0, 19).replace('T', ' ');
  },
  getDate: function (days = 0) {
    let date = new Date();
    date.setDate(date.getDate() + days)
    return date.toISOString().slice(0, 10).replace('T', ' ');
  },
  getWeek: function (offset = 0) {
    let nn = new Date()
    let dd = new Date(nn.getFullYear(), 0, 1)
    let days = Math.floor((nn - dd) / (24 * 60 * 60 * 1000))
    return Math.ceil(days / 7) + offset;
  },
  getEndMonth: function () {
    const fechaActual = new Date();
    const mes = fechaActual.getMonth();
    const anio = fechaActual.getFullYear();
    const ultimoDia = new Date(anio, mes + 1, 0);
    return ultimoDia.toISOString().split('T')[0];
  },
  setCookie: function (name, value) {
    document.cookie = `${name}=${value || ""}; path=/`;
  },
  getCookie: function get(name) {
    const matches = document.cookie.match(new RegExp(
      "(?:^|; )" + name.replace(/([\.$?*+\^\]\[(){}|\\/])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : null;
  },
  getTable(url) { // obtiene la ultima parte de una url "db/aa/bb" obtiene bb
    return url.slice(url.lastIndexOf('/') + 1);
  },
  replace: function (text, arrayTags) {
    const pattern = /:([a-zA-Z]+)/g;
    return text.replace(pattern, (match, tag) => {
      if (arrayTags && typeof arrayTags === 'object' && arrayTags.hasOwnProperty(tag)) {
        return arrayTags[tag];
      }
      return match; // Si el tag no existe, devuelve el match original
    });
  }
}

const log = {
  off: function (d) {
    user.logged = false
    db("/log/off", {})
    const sheetOff = window.open(`https://${config.url}/file/webapi/entry.cgi?api=SYNO.API.Auth&method=logout&version=7`, 'Desconectar', 'left=1,top=1,width=1,height=1,status=no,menubar=no,toolbar=no,scrollbars=no,resizable=no');
    setTimeout(function () {
      sheetOff.close();
      log.on()
    }, 500);
  },
  on: async function () {
    const r = await db("/log/on", {})
    window.location.href = `https://${config.url}/webman/sso/SSOOauth.cgi?app_id=${r.appid}&scope=user_id&synossoJSSDK=false&redirect_uri=${r.redirect}`
  },
  check: async function () {
    var url = window.location.href;
    var params = new URLSearchParams(url.split('#/')[1]);
    var token = params.get('access_token') ?? false;
    const res = await db("/log/check", { token: token, area: user.area })
    if (res.success === true) {
      user.logged = true
      user.name = res.user.name;
      user.mail = res.user.mail;
      user.adm = res.user.adm;
      user.menu = res.user.menu;
      user.area = res.user.area;
      user.areas = res.user.areas ? res.user.areas.toString().split(",").map(Number) : false;
      return true;
    }
    this.on();
    return false;
  }
}

// EXPORT 
export default {
  user, data, log, db
};